import { __awaiter } from "tslib";
import { AppState } from '../etc/stores';
import { Container } from './container';
import { StatefulService } from './stateful-service';
import Analytics from './analytics';
import sessionKeys from '../etc/sessionKeys';
import { SessionManager } from './session-manager';
import { Logger } from './logger';
import { getCoinsExpiringSoon } from '../etc/utils';
import flagKeys from '../etc/flagKeys';
export class Customer extends StatefulService {
    constructor() {
        super(...arguments);
        this.session = this.ctx.get(SessionManager);
        this.logger = this.ctx.get(Logger).context(Customer.name);
        this.hasPendingCoins = () => {
            return +this.getPendingCoins() > 0;
        };
    }
    loadState() {
        return __awaiter(this, void 0, void 0, function* () {
            const { auth, business } = this.getAppState();
            if (auth.access_token && business.id) {
                const customer = yield this.backend.getCustomer();
                yield this.loadWallet(customer);
                this.logger.identifyCustomer(customer.id);
                Analytics.identify(customer.id, {
                    name: `${customer.name} ${customer.lastname}`,
                    mail: customer.mail,
                    email: customer.mail,
                    phone: customer.phone,
                    birthday: customer.birthday
                });
            }
        });
    }
    getPendingCoins() {
        var _a;
        let pendingCoins = (_a = this.getAppState().customer.wallet) === null || _a === void 0 ? void 0 : _a.pendingCoins;
        if (this.session.get(sessionKeys.CHECKOUT_WITHOUT_TRANSACTION)) {
            pendingCoins = Number(pendingCoins) * 100;
            pendingCoins =
                (pendingCoins +
                    this.session.get(sessionKeys.CHECKOUT_WITHOUT_TRANSACTION)
                        .coinsAmount) /
                    100;
        }
        return pendingCoins;
    }
    getExpiringCoins() {
        var _a;
        return ((_a = this.getAppState().customer.wallet) === null || _a === void 0 ? void 0 : _a.expiringCoins) || 0;
    }
    loadWallet(customerInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            const { business, featureFlags } = this.getAppState();
            const defaultWalletData = { money: '0', coins: '0', pendingCoins: '0' };
            const businessId = business.id;
            const isSoftUser = yield this.backend.isSoftLogin();
            let requests = [this.backend.getCustomerWallet(businessId)];
            if (featureFlags.includes(flagKeys.EXPIRABLE_COINS) && !isSoftUser) {
                requests.push(this.backend.getCustomerExpiringCoins({ businessId, rangeDays: '30' }));
            }
            const [walletResponse = defaultWalletData, expirableCoinsResponse = []] = yield Promise.all(requests);
            const { coinsExpiringSoon } = getCoinsExpiringSoon(expirableCoinsResponse);
            AppState.update(state => (Object.assign(Object.assign({}, state), { customer: Object.assign(Object.assign({}, (customerInfo || state.customer)), { wallet: Object.assign(Object.assign({}, walletResponse), { coinsExpiringSoon }) }) })));
        });
    }
}
Container.add(Customer);
